import { render, staticRenderFns } from "./statements.vue?vue&type=template&id=4e419b54"
import script from "./statements.vue?vue&type=script&lang=js"
export * from "./statements.vue?vue&type=script&lang=js"
import style0 from "./statements.vue?vue&type=style&index=0&id=4e419b54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports